import { getFromLocalStorage, saveToLocalStorage } from './storageUtils';
import { defaultCharactersConfig } from './defaultConfig';
import { getConfigFunctionEndpoint, saveConfigFunctionEndpoint } from '../common/Constants';

export const getConfig = async (userId, accessToken) => {
  // use the accessToken to fetch the config from the table storage
  const payload = { userId: userId };
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`
  };

  //console.info("Fetching config from Azure Table Storage (request = ", headers, JSON.stringify(payload));

  return fetch(getConfigFunctionEndpoint, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
  }).then(async (response) => {
    if (!response.ok) {
      //console.error('Error fetching config:', response);
      //console.error('Using default config instead!!!!!!');
      let config = getFromLocalStorage('aiCharactersConfig');

      if (config && !Array.isArray(config)) {
        // If the config is found in local storage, parse it from JSON string to object/array.
        config = JSON.parse(config);
      } else {
        try {
          // Fetch the config from the JSON file if not found in local storage
          config = defaultCharactersConfig;
          // Save the fetched config to local storage for future use
          saveConfig(userId, accessToken, JSON.stringify(config));
        } catch (error) {
          //console.error('Error loading AI Characters config:', error);
          config = [];
        }
      }
      // Ensure that the returned config is always an array
      return Array.isArray(config) ? config : [];
    } else {
      const config = await response.json();
      //console.info("Configuration fetched successfully:", config);
      return config;
    }
  }).catch((error) => {
    console.error('Error loading config:', error);
    return [];
  });
};

export const saveConfig = async (userId, accessToken, updatedConfigs) => {

  // Convert the array/object to a JSON string before saving to local storage
  saveToLocalStorage('aiCharactersConfig', JSON.stringify(updatedConfigs));

  const payload = {
    updatedConfigs: { ...updatedConfigs },
    userId: userId,
  };
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`
  };
  ////console.debug("Save Configuration Endpoint: ", saveConfigFunctionEndpoint);
  return fetch(saveConfigFunctionEndpoint, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(payload),
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    } else {
      //console.info("Configuration saved successfully! ", response);
    }
  }).catch((error) => {
    //console.error("Error saving configuration to Azure Table Storage:", error.message);
  });
};
